export const themeTabs = {
  appearance: 'appearance',
  textStyles: 'textStyles',
}

export const themeTabOptions = [
  { label: 'Apariencia', value: themeTabs.appearance },
  { label: 'Estilos de texto', value: themeTabs.textStyles },
]
